(() => {
  const protectContactForms = () => {
    const contactForms = document.querySelectorAll('form[action*="/contact"]');

    contactForms.forEach((form) => {
      const formType = form.querySelector('input[name="form_type"]');
      if (!formType || formType.value !== 'contact') return;
      if (form.dataset.sepetnetAntispamBound === 'true') return;
      form.dataset.sepetnetAntispamBound = 'true';

      form.addEventListener(
        'submit',
        (event) => {
          const honeypot = form.querySelector(
            '.sepetnet-contact-honeypot input[name="contact[company_website]"]',
          );

          if (honeypot && honeypot.value.trim() !== '') {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true,
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', protectContactForms, { once: true });
  } else {
    protectContactForms();
  }
})();